import { cx } from "../lib/cx";

interface StatusBadgeProps {
  label: string;
  tone?: "positive" | "warning" | "neutral";
}

export function StatusBadge({ label, tone = "neutral" }: StatusBadgeProps) {
  return <span className={cx("status-badge", `tone-${tone}`)}>{label}</span>;
}
